import React, { Fragment, useEffect, useState } from 'react';
import { Button, Col, Container, Input, Row, Table } from 'reactstrap';
import { toast } from "react-toastify";
import _ from 'lodash';
import { FilterSelect, ServiceThreadSpinner } from '.';
import { api, filterHelpers } from '../utils';
import { confirmAlert } from "react-confirm-alert";

export default function ManagePurchaseSites() {
   const ALL_OPT = { value: "0", label: "-- Select --", description: "", isActive: false };
   const INIT_MODEL = { siteId: "0", siteDesc: "", isActive: true };
   const [locn, setLocn] = useState(INIT_MODEL);
   const [locnList, setLocnList] = useState([]);
   const [filters, setFilters] = useState([
      { filterName: "location", value: ALL_OPT }
   ]);
   const [editLocn, setEditLocn] = useState("");
   const [newLocn, setNewLocn] = useState("");
   const [spinLocn, setSpinLocn] = useState(true);

   useEffect(() => {
      runQuery();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   function ActivateLocn() {
      if (!locn || locn.siteId === "0") {
         toast.error("Please select a location to activate");
         return;
      }

      setSpinLocn(true);
      api.post(`Purchasing/ActivateConsignedSite/${locn.siteId}`)
         .then((response) => {
            if (response.data.success) {
               toast.success("Site activated!")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinLocn(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinLocn(false);
         });
   }

   function DeleteLocn() {
      setSpinLocn(true);
      api.post(`Purchasing/DeleteConsignedSite/${locn.siteId}`)
         .then((response) => {
            if (response.data.success) {
               toast.success("Location was successfully deleted or made inactive!")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinLocn(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinLocn(false);
         });
   }

   function onLocnChange(newFilterValue) {
      let newFilters = filterHelpers.getFilters(filters, newFilterValue);
      setFilters(newFilters);

      setNewLocn(""); // Clear any lingering values
      if (newFilterValue.value === "0") {
         setLocn(INIT_MODEL);
         setEditLocn("");
      }
      else { // Get the location to be edited
         const d = _.find(locnList, (x) => x.value === newFilterValue.value);
         let changes = Object.assign({}, locn);
         changes.siteDesc = newFilterValue.description;
         changes.siteId = newFilterValue.value;
         changes.isActive = d.isActive;
         setLocn(changes);
         setEditLocn(newFilterValue.value);
      }
   }

   function runQuery() {
      setSpinLocn(true);
      api
         .fetch(`Purchasing/LoadAllConsignedSites`)
         .then((response) => {
            if (response.data.success) {
               const fullList = _.concat([ALL_OPT],
                  _.map(response.data.sites, (d) => ({
                     value: d.siteId,
                     label: d.siteWithDesc,
                     description: d.siteDesc,
                     isActive: d.isActive
                  })));
               return { fullList: fullList };
            } else {
               toast.error(response.data.message);
            }
         })
         .then(({ fullList }) => {
            setLocnList(fullList);
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
         })
         .finally(() => {
            setEditLocn("");
            setNewLocn("")
            setLocn(INIT_MODEL);
            setSpinLocn(false);
         });
   }

   function SaveNewLocn() {
      if (!newLocn || newLocn.length < 1) {
         toast.error("Please provide a site Id");
         return;
      }
      setSpinLocn(true);
      api.post(`Purchasing/SaveConsignedSite/${newLocn}`)
         .then((response) => {
            if (response.data.success) {
               toast.success("Consigned site added!")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinLocn(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinLocn(false);
         });
   }

   const ShowDeleteModal = () => {
      if (!locn || locn.siteId === "0") {
         toast.error("Please select a location");
         return;
      }
      confirmAlert({
         title: "Confirm Deletion or Inactivation",
         message: `Are you sure you want to delete the ${editLocn} site?`,
         buttons: [
            { label: "Yes", onClick: () => { DeleteLocn() } },
            { label: "No" }
         ]
      });
   }

   return (
      <Container fluid>
         <Row>
            <Col>
               <Fragment>
                  <ServiceThreadSpinner on={spinLocn}>
                     <Row className="px-2 py-2">
                        <Col xxl={{ offset: 0, size: 12 }}>
                           {locnList && locnList.length ? (
                              <Table className="transparent-background my-0">
                                 <tbody>
                                    <tr>
                                       <td className="transparent-background data-cell noWrap h6" width="80px">
                                          Site:
                                       </td>
                                       <td className="transparent-background" width="500px">
                                          <FilterSelect
                                             filterName="location"
                                             options={locnList}
                                             value={filterHelpers.getValue(filters, "location")}
                                             onChangeCallback={e => onLocnChange(e)}
                                          />
                                       </td>
                                       <td className="transparent-background"></td>
                                    </tr>
                                 </tbody>
                              </Table>
                           ) : null}
                        </Col>
                     </Row>

                     {locn && locn.siteId !== "0" ? (
                        <div>
                           <Row className="px-0 py-0">
                              <Table className="transparent-background data-table">
                                 <tbody>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td colSpan={5} className="transparent-background data-cell noWrap h6">
                                          Deleting a site that has purchases assigned to it will set it to inactive.
                                       </td>
                                    </tr>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td colSpan={5} className="transparent-background data-cell noWrap h6">
                                          Inactive sites will not show up in vendor purchasing search options.
                                       </td>
                                    </tr>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td className="transparent-background data-cell width95px noWrap h6">
                                          Id: {locn.siteId}
                                       </td>
                                       <td className="transparent-background data-cell noWrap h6 width115px">
                                          Active: {locn.isActive ? "Yes" : "No"}
                                       </td>
                                       <td colSpan={3} className="transparent-background data-cell"></td>
                                    </tr>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td className="transparent-background data-cell noWrap h6 width115px">
                                          Site Name: {locn.siteDesc}
                                       </td>
                                       <td className="transparent-background data-cell width115px">
                                          <Button title="Delete" className="shredButton" onClick={() => ShowDeleteModal()}>
                                             Delete
                                          </Button>
                                       </td>
                                       {!locn.isActive ? (
                                          <td className="transparent-background data-cell">
                                             <Button title="Reactivate" className="shredButton" onClick={() => ActivateLocn()}>
                                                Reactivate
                                             </Button>
                                          </td>
                                       ) : <td className="transparent-background data-cell"></td>}
                                    </tr>
                                 </tbody>
                              </Table>
                           </Row>
                        </div>
                     ) : null}

                     <br />
                     <br />
                     <hr />
                     <Row className="px-2 py-2">
                        <Col xxl={{ offset: 0, size: 12 }}>
                           Add New Consigned Site
                        </Col>
                     </Row>
                     <Row className="px-2 py-2">
                        <Col xxl={{ offset: 0, size: 12 }}>
                           <Table className="transparent-background my-0">
                              <tbody>
                                 <tr>
                                    <td className="transparent-background data-cell noWrap h6" width="80px">
                                       Site Id:
                                    </td>
                                    <td className="transparent-background" width="500px">
                                       <Input
                                          type="text"
                                          value={newLocn || ""}
                                          onChange={(e) => setNewLocn(e.target.value)}
                                          maxLength="100"
                                       />
                                    </td>
                                    <td className="transparent-background">
                                       <Button title="New Consigned Site" className="shredButtonExcel ms-2" onClick={() => SaveNewLocn()}>
                                          Add Site
                                       </Button>
                                    </td>
                                 </tr>
                              </tbody>
                           </Table>
                        </Col>
                     </Row>
                  </ServiceThreadSpinner>
               </Fragment>
            </Col>
         </Row>
      </Container>
   );
}
